<template>
  <div class="partEdit" v-if="part && currentProject._id">
    <button @click="showModal" class="unassigned">{{ part.title }} - {{ parent }}</button>
    <modal
      scrollable
      classes="modalBoon assignModal"
      transition="nice-modal-fade"
      height="auto"
      :name="part._id"
      :clickToClose="false"
      :delay="100"
      :width="300"
    >
      <button class="modal-close-button" @click="closeModal">
        <b-icon icon="x" />
      </button>

      <div>
        <div class="partContainer">
          <div class="partIntro bo-padding-std">
            <div class="titles">
              <div v-if="parent" class="parent">{{ parent }}</div>
              <div v-if="parent">
                {{ part.title }}
                <debug :object="part" />
              </div>
            </div>
          </div>
          <div>
            <h3>{{ $t('Assign worker') }}</h3>
            <p>
              {{
                $t(
                  'Worker not assigned, please fill in below and go through project settings and make sure all others is accurate.'
                )
              }}
            </p>
          </div>
          <div class="acc-title-wrapper" v-if="selectedPartManager._id">
            <div class="acc-title">
              {{ $t('Responsible') }}
            </div>
            <div class="acc-subtitle line-clamp-1">
              <strong>
                <span>
                  {{ personCompanyOrPersonName(selectedPartManager._id) }}
                </span>
              </strong>
            </div>
          </div>

          <b-labelled v-if="hasPropertyPermissions('Part', 'partOccupation')" :title="$t('Step 1')">
            <p>{{ $t('UE-Link (connection to performer of moment in project settings)') }}</p>
            <multiselect
              class="boon-multiselect"
              :custom-label="(p) => $t(p)"
              :disabled="!hasPropertyPermissions('Part', 'partOccupation')"
              :multiple="false"
              :options="currentProjectRoles"
              :placeholder="$t(inheritedOccupation)"
              :value="part.partOccupation"
              @input="updateSimpleProperty('partOccupation', $event)"
              id="partOccupation"
            >
              <div slot="noResult">
                {{ $t('No matching expertise found') }}
              </div>
            </multiselect>
          </b-labelled>

          <b-labelled :title="$t('Step 2')">
            <p>{{ $t('Performing company for labour') }}</p>
            <multiselect
              class="boon-multiselect"
              :custom-label="(p) => personCompanyName(p._id)"
              :disabled="!hasPropertyPermissions('Part', 'partSubcontractorId')"
              :multiple="false"
              :options="allPersonsCompanyList"
              @open="allPersonsCompanyList = groupedPersons()"
              :placeholder="defaultSubContractor"
              :value="selectedPartManager"
              @input="updateSimpleProperty('partSubcontractorId', $event ? $event._id : '')"
              group-label="companyName"
              group-values="persons"
              track-by="_id"
            >
              <div slot="noResult">
                {{ $t('No matching person found') }}
              </div>
            </multiselect>
          </b-labelled>
        </div>
        <button class="next-btn pure-material-button-contained mt-4" @click="reAssign">
          <b-icon icon="arrow-right-short" />
        </button>
      </div>
    </modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as treeHelpers from '@/common/treeHelpers';
import BLabelled from '@/components/toolbar/BLabelled';
import Multiselect from 'vue-multiselect';

export default {
  name: 'DiaryPartEdit',
  props: ['diaryEntry', 'part'],
  data: function () {
    console.log('DiaryPartEdit data f');
    return {
      allPersonsCompanyList: [{ _id: false }],
    };
  },
  methods: {
    ...mapActions(['addPartComment', 'savePartProperties', 'updateDiaryUnassigned']),
    updateSimpleProperty: function (property, newValue) {
      if (this.part[property] !== newValue) {
        var newPartProperties = {};
        newPartProperties[property] = newValue;
        this.savePartProperties({ updatePart: this.part, newPartProperties });
      }
    },
    showModal: function (e) {
      this.$modal.show(this.part._id);
    },
    reAssign: function (e) {
      this.$modal.hide(this.part._id);
      this.updateDiaryUnassigned({ diaryEntry: this.diaryEntry, part: this.part });
    },
    closeModal: function (e) {
      this.$modal.hide(this.part._id);
    },
  },
  computed: {
    ...mapGetters([
      'currentProject',
      'currentProjectRoles',
      'getPerson',
      'fetchStage',
      'findNearestParentProperty',
      'groupedPersons',
      'hasSimplePermissions',
      'hasRole',
      'hasPropertyPermissions',
      'personCompanyName',
      'personCompanyOrPersonName',
      'personName',
    ]),
    parent: function () {
      if (!this.part) {
        return '';
      }
      const parent = treeHelpers.findParent(this.currentProject, this.part._id);

      if (parent) {
        const stage = this.fetchStage(parent._id);
        return stage.title;
      }

      return '';
    },
    inheritedOccupation: function () {
      if (this.part.partOccupation) {
        return this.part.partOccupation;
      }

      var parent = treeHelpers.findParent(this.currentProject, this.part._id);
      var occupation;
      while (!occupation && parent && parent !== this.currentProject) {
        occupation = this.fetchStage(parent._id).stageOccupation;
        if (!occupation) {
          parent = treeHelpers.findParent(this.currentProject, parent._id);
        }
      }
      if (!occupation) {
        return '';
      }
      return occupation;
    },
    managerId: function () {
      if (this.part.partManagerId) {
        return this.part.partManagerId;
      }

      return this.findNearestParentProperty(
        this.currentProject,
        this.part._id,
        'stageManagerId',
        'developingManagerId'
      );
    },
    selectedPartManager: function () {
      if (this.part.partSubcontractorId !== '') {
        return this.getPerson(this.part.partSubcontractorId);
      }
      return '';
    },
    defaultSubContractor: function () {
      if (!this.inheritedOccupation) {
        return this.$t('Subcontractor not assigned');
      }

      var subcontractor = this.currentProject.projectSubcontractors.find(
        (p) => p.occupation === this.inheritedOccupation
      );
      if (!subcontractor) {
        subcontractor = this.currentProject.projectManagers.find((p) => p.occupation === this.inheritedOccupation);
      }

      if (!subcontractor || !subcontractor.personId) {
        return this.$t('Subcontractor for {occupation} not assigned', {
          occupation: this.$t(this.inheritedOccupation),
        });
      }
      // console.log(this.personCompanyName(subcontractor.personId));
      return this.personCompanyName(subcontractor.personId);
    },
    isDefaultSubContractor: function () {
      if (!this.part.partOccupation) {
        return false;
      }
      if (this.part.partSubcontractorId) {
        return false;
      }

      var subcontractor = this.currentProject.projectSubcontractors.find(
        (p) => p.occupation === this.part.partOccupation
      );
      if (!subcontractor) {
        subcontractor = this.currentProject.projectManagers.find((p) => p.occupation === this.part.partOccupation);
      }

      if (!subcontractor || !subcontractor.personId) {
        return false;
      }
      return true;
    },
  },
  components: {
    BLabelled,
    Multiselect,
  },
};
</script>

<style scoped>
.unassigned {
  color: #f97c7c;
}
.partEdit {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 10px;
}
.partContainer {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  color: black;
  font-family: Montserrat;
  font-size: 12px;
}
.partContainer h3 {
  font-weight: 500;
  font-size: 26px;
}
.bo-padding-std {
  padding-left: 15px;
  padding-right: 15px;
}
button {
  display: inline-flex;
  align-self: flex-start;
  cursor: pointer;
}
button.next-btn {
  font-size: 1.75rem;
  margin: 2px;
  display: inline-flex;
  align-self: flex-end;
  cursor: pointer;
}
button.next-btn .b-icon {
  font-size: 2em;
  color: #1c2731;
  transform: translateY(0);
}
button.next-btn.active .b-icon {
  color: #c9783d;
}
button:disabled .b-icon {
  color: gray;
}
.workDates {
  font-size: 80%;
}
.titles {
  padding-top: 10px;
  padding-bottom: 10px;
}
.parent:before {
  content: '> ';
}
.parent {
  font-size: 0.7em;
  font-weight: 600;
  color: #d67d07;
  /* webkit-font-smoothing: subpixel-antialiased;
	*/
}
.partTitle {
  font-size: 1.5em;
  font-weight: 400;
  /*text-transform: capitalize;
	*/
  margin-bottom: 5px;
}
.partTitle:hover {
  outline: 1px solid #999;
}
/* TODO */
.title {
  text-align: center;
  display: block;
  font-size: 1.2em;
  cursor: pointer;
  padding: 5px 0;
}
/* Standard button */
.button-dark {
  position: relative;
  background-color: #1c2731;
  border: none;
  color: #fff;
  padding: 0.5em 1em;
  width: auto;
  text-align: center;
  transition-duration: 0.4s;
  text-decoration: none;
  overflow: hidden;
  cursor: pointer;
}
.button-dark:after {
  content: '';
  background: #f1f1f1;
  display: block;
  position: absolute;
  padding-top: 300%;
  padding-left: 350%;
  margin-left: -20px !important;
  margin-top: -120%;
  opacity: 0;
  transition: all 0.8s;
}
.button-dark:active:after {
  padding: 0;
  margin: 0;
  opacity: 1;
  transition: 0s;
}
.button-bordered {
  background: #fff;
  color: #333;
  padding: 0.36em 1em;
  border: 0.14em solid #333;
  border-radius: 10em;
}
.button-bordered:hover {
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/diary/DiaryPartEdit.vue